import React, {Component} from 'react';
import Master from './Master';
import Require from './Require';
import LoginPage from '../pages/LoginPage';
import {loadAccount} from '../../model/action-creators/account-actions';
import {doPostLogin} from '../../model/action-creators/login-actions';

class App extends Component {
    componentWillMount() {
        const dispatch = this.context.store.dispatch;
        const router = this.props.router;
        dispatch(loadAccount()
        ).then(() => {
            return dispatch(doPostLogin(true, router, "/overview"));
        }).catch((error) => {
            console.error("On preload", error);
        });
    }

    render() {
        return (
            <Require loggedIn={true}>
                <Master> {this.props.children} </Master>
                <LoginPage/>
            </Require>
        );
    }
}
App.contextTypes = {
    store:React.PropTypes.object
};

export default App;



// WEBPACK FOOTER //
// ./src/ui/components/App.js